import React, { FC } from 'react';
import { CheckCont, CompareFilterTileCont, TileContent } from './CompareFilterTile.styles';
import CheckIcon from '@/assets/icons/checkMark.svg?react';

interface ICompareFilterTile {
  data: { id: string; name: string };
  setSelected: (val: string) => void;
  selected?: boolean;
}
const CompareFilterTile: FC<ICompareFilterTile> = ({ selected, data, setSelected }) => {
  const { id, name } = data;
  return (
    <CompareFilterTileCont
      data-testid="CompareFilterTileCont"
      onClick={() => setSelected(id)}
      selected={selected}
    >
      <TileContent id="TileContent">{name}</TileContent>
      {selected && (
        <CheckCont data-testid="CheckCont">
          <CheckIcon />
        </CheckCont>
      )}
    </CompareFilterTileCont>
  );
};
export default CompareFilterTile;
